import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

import AlertaContext from '../../context/alertas/alertaContext';
import AuthContext from '../../context/autenticacion/authContext';

const NuevaCuenta = (props) => {

    // extraer los valores del context
    const alertaContext = useContext(AlertaContext);
    const { alerta, mostrarAlerta } = alertaContext;

    const authContext = useContext(AuthContext);
    const { mensaje, autenticado, registrarUsuario } = authContext; 

    // en caso de que el ususario se haya autenticado, o registrado, o sea un registro duplicado
    useEffect(() => {
        if (autenticado) {
            props.history.push('/proyectos');
        }
        if (mensaje) {
            mostrarAlerta(mensaje.msg, mensaje.categoria);
        }
        // eslint-disable-next-line
    }, [mensaje, autenticado, props.history])


    // state par iniciar sesion
    const [usuario, setUsuario] = useState({
        nombre: '',
        email: '',
        password: '',
        confirmar: ''
    })

    const { nombre, email, password, confirmar } = usuario;

    const onChange = e =>{
        setUsuario({
            ...usuario,
            [e.target.name] : e.target.value
        })
    }

    // cuando el usario quiere iniciar sesion

    const onSubmit = e => {
        e.preventDefault();

        // Validar que no haya campos vacios
        if(nombre.trim() === '' || email.trim() === '' || password.trim() === '' || confirmar.trim() === '' ) {
            mostrarAlerta('Todos los campos son obligatorios', 'alerta-error');
            return;
        }

        // psw minimo de 6 caracteres
        if (password.length < 6) {
            mostrarAlerta('El password debe contener mínimo 6 caracteres', 'alerta-error');
            return;
        }

        // revisar que los dos psw sean iguales
        if (password !== confirmar) {
            mostrarAlerta('El password y su confirmación no son iguales', 'alerta-error');
            return;
        }

        // Pasarlo al action
        registrarUsuario({
            nombre,
            email,
            password
        })
    }

    return ( 
        <>
        <h1>ELECTRO<span>NATURAL</span></h1>
        <div className="form-usuario">
            {alerta ? (<div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div>) : null}
            <form
                className="contenedor-form"
                onSubmit={onSubmit}
            >
            
            <fieldset>
                <h1 className="form-label">Obtener una Cuenta</h1>        
                
                    <div className="mb-3">
                        <label htmlFor="nombre" className="form-label">Nombre</label>
                        <input 
                            type="text"
                            id="nombre"
                            className="form-control input-text"
                            name="nombre"
                            value={nombre}
                            placeholder="Tu nombre"
                            onChange={onChange}
                            aria-describedby="nombre"/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input 
                            type="email"
                            id="email"
                            className="form-control input-text"
                            name="email"
                            value={email}
                            placeholder="Tu Email"
                            onChange={onChange}
                            aria-describedby="email"/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input 
                            type="password"
                            id="password"
                            className="form-control input-text" 
                            name="password"
                            value={password}
                            placeholder="Tu password"
                            onChange={onChange}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="confirmar" className="form-label">Confirmar Password</label>
                        <input 
                            type="password"
                            id="confirmar"
                            className="form-control input-text" 
                            name="confirmar"
                            value={confirmar}
                            placeholder="Confirmar password"
                            onChange={onChange}
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-primary text-uppercase d-block w-100"
                        value="Hacer el registro"
                    >Hacer el registro</button>
                </fieldset>
                <Link 
                    to={'/'} 
                    className="enlace-cuenta"
                >Volver a Iniciar Sesión</Link>
            </form>
            
            
        </div>
        </>
    );
}
 
export default NuevaCuenta;